import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "text-center font-light whitespace-pre-line" }
const _hoisted_3 = { class: "w-full flex justify-center" }

import {
		useRoute,
		useRouter
	} from 'vue-router'

	import {
		computed,
		onBeforeMount,
		ref
	} from 'vue'
	// store

	import { 
		localesStore
	} from '@/store/locales'

	import { 
		store as _userStore
	} from '@/store/user'

	import { 
		store as _valueListStore
	} from '@/store/valueLists'
    
	// language
	import {
		useI18n
	} from 'vue-i18n'

	
	const __default__ = { name: 'WelcomeForm' } 	// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		modelValue: {
			type: Boolean,
			default: true
		},
	},
  emits: [
		'update:modelValue'
	],
  setup(__props, { emit: __emit }) {


	const props = __props

	const emit = __emit
	const {t} = useI18n()

	function goToLogin() {
		emit('update:modelValue', false)
	}


return (_ctx: any,_cache: any) => {
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('welcome.welcomeMessage')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_tw_button, {
        class: "btn-brand w-1/2",
        onClick: goToLogin
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('welcome.continueButton')), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})